export const state = {
  list: [],
  pagination: null,
  model: null,
}
